<template>
    <b-card>
        <b-row>
            <b-col lg="12">
                <b-card header="Select Date Range"
                        header-text-variant="white"
                        header-bg-variant="info"
                >
                    <b-form inline @submit.prevent="fetch()">
                        <date-picker
                            v-model="start_date"
                            placeholder="Start Date"
                        >
                        </date-picker> &nbsp;to&nbsp;
                        <date-picker
                            v-model="end_date"
                            placeholder="End Date"
                        >
                        </date-picker>
                        <b-form-select
                            id="caregiver_id"
                            name="caregiver_id"
                            v-model="caregiver_id"
                        >
                            <option value="">All Providers</option>
                            <option v-for="caregiver in caregivers" :value="caregiver.id" :key="caregiver.id">{{ caregiver.name }}</option>
                        </b-form-select>
                        <b-form-select
                            id="client_id"
                            name="client_id"
                            v-model="client_id"
                        >
                            <option value="">All Claimants</option>
                            <option v-for="client in clients" :value="client.id" :key="client.id">{{ client.name }}</option>
                        </b-form-select>
                        <carrier-dropdown v-model="carrier" emptyText="All Carriers"></carrier-dropdown>
                        &nbsp;
                        <b-button type="submit" variant="info" :disabled="loading">Generate Report</b-button>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>

        <div class="table-responsive" >
            <div class="text-right mb-3">
                <b-btn variant="success" :href="`${url}&export=1`" :disabled="loading">
                    <i class="fa fa-file-excel-o"></i> Export to Excel
                </b-btn>
            </div>

            <loading-card v-if="loading"></loading-card>

            <b-table bordered striped hover show-empty
                :items="items"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                v-if="!loading"
            >
                <template v-slot:cell(id)="row">
                    <b-btn size="sm" @click.stop="details(row.item)">View Shift</b-btn>
                </template>
                <template v-slot:cell(checked_in_time)="row">
                  <utc-time :time="row.item.checked_in_time" role="role" />
                </template>
            </b-table>
        </div>

        <!-- Details modal -->
        <business-shift-details-modal :shift="selectedItem" v-model="detailsModal" />
    </b-card>
</template>

<script>
    import FormatsDates from "../../../mixins/FormatsDates";

    export default {
        mixins: [FormatsDates],

        props: {
          caregivers: {
            type: Array,
            default: () => [],
          },
          clients: {
            type: Array,
            default: () => [],
          },
          role: {
            type: String,
            default: '',
          },
        },

        data() {
            return {
                selectedItem: {
                    client: {}
                },
                detailsModal: false,
                items: [],
                totalItems: 0,
                sortBy: 'date',
                sortDesc: false,
                loading: false,
                end_date: moment(new Date()).format('MM/DD/YYYY'),
                start_date: moment(new Date()).subtract(14, 'days').format('MM/DD/YYYY'),
                caregiver_id: "",
                client_id: "",
                carrier: '',
                fields: [
                    {
                        key: 'checked_in_time',
                        formatter: d => this.formatDateTimeFromUTC(d),
                        sortable: true,
                        label: 'Clocked In Time',
                    },
                    {
                        key: 'client_name',
                        label: 'Claimant',
                        sortable: true,
                    },
                    { key: 'carrier', sortable: true },
                    {
                        key: 'caregiver_name',
                        label: 'Provider',
                        sortable: true,
                    },
                    {
                        key: 'id',
                        label: 'Actions',
                    },
                ]
            }
        },

        computed: {
            url() {
                return `/business/reports/falls?json=1&start_date=${this.start_date}&end_date=${this.end_date}&client=${this.client_id}&caregiver=${this.caregiver_id}&carrier=${this.carrier}`;
            }
        },

        methods: {
            fetch() {
                this.loading = true;
                axios.get(this.url)
                    .then( ({ data }) => {
                        this.items = data;
                        this.totalItems = this.items.length;
                        this.loading = false;
                    })
            },

            details(item) {
                axios.get('/business/shifts/' + item.id)
                    .then(response => {
                        let shift = response.data;
                        shift.checked_in_time = moment.utc(shift.checked_in_time).local().format('L LT');
                        shift.checked_out_time = moment.utc(shift.checked_out_time).local().format('L LT');
                        this.selectedItem = shift;
                        this.detailsModal = true;
                    })
                    .catch(e => {
                        alert('Error loading shift details');
                    });
            },
        },

        mounted() {
        },
    }
</script>
